import { Col, DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import {
  StyledBackground,
  StyledCard,
  StyledRow,
} from 'features/auth/routes/login.styles';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { ItemUniversalLink } from 'features/document-report/components/upload-universal/documents-upload-universal';
import { useUserContext } from 'features/users';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { disabledDate } from 'routes/utils';
export const UploadUniversalDocuments = () => {
  const params = useParams();
  const { id, clientid } = params;
  const { companyUser } = useUserContext();
  const [dataCategory, setCategoryData] = useState<any>('');
  const [year, setYear] = useState(dayjs().year().toString());
  const [month, setMonth] = useState((dayjs().month() + 1).toString()); // Month is 0-indexed
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const handleDateChange = (date: any) => {
    if (date) {
      // Update to the selected date
      setSelectedDate(date);
      setYear(date.year().toString());
      setMonth((date.month() + 1).toString());
    } else {
      // Reset to the current date when cleared
      const currentDate = dayjs();
      setSelectedDate(currentDate);
      setYear(currentDate.year().toString());
      setMonth((currentDate.month() + 1).toString());
    }
  };
  const getAllCompanyIds = () => {
    // Check if `companyUser` and `rc` array exist
    if (companyUser?.rc?.length > 0) {
      // Map through the `rc` array to extract all `CompanyId` values
      return companyUser.rc.map((item: any) => item.CompanyId);
    }

    // Fallback to returning an empty array if `rc` is not found or empty
    return [];
  };
  const companyIds = getAllCompanyIds();
  const initialValues = async () => {
    try {
      const apires: any = await DocumentsApiService().dropDownByClassFlag({
        Flag: 'Category',
        CompanyId: id,
        ClientId: clientid,
      });
      setCategoryData(apires);
    } catch (error: any) {
      message.error(error);
    }
  };
  useEffect(() => {
    initialValues();
  }, []);

  return (
    <StyledBackground>
      <Col
        xs={24}
        sm={18}
        md={12}
        lg={12}
        xl={10}
        xxl={6}
        className='flex flex-col justify-center'
      >
        <Col xs={24} className='flex justify-center mb-10'>
          <img src='/partnerplus_logo.png' alt='login background' />
        </Col>
        <StyledCard>
          <StyledRow justify='center'>
            {companyIds.includes(id) && (
              <Col>
                <label className='mt-0 mb-3 text-center text-2xl font-bold text-blue-950'>
                  Upload Documents
                </label>
                {/* <label className='mt-0 mb-5 text-center text-md font-medium tracking-tight text-gray-900'>Partner Plus Customer Portal</label> */}
              </Col>
            )}
          </StyledRow>
          {companyIds.includes(id) && (
            <div className='w-full mb-3'>
              <label className='mb-3 block'>Select Date</label>
              <DatePicker
                className='w-full'
                format='MMMM YYYY' // Display as "Month Name YYYY"
                defaultValue={dayjs()} // Default to current month/year
                disabledDate={disabledDate}
                picker='month'
                value={selectedDate} // Controlled value
                onChange={handleDateChange as any}
              />
            </div>
          )}

          <StyledRow justify='center'>
            <Col xs={24}>
              {/* <DocumentsItemUniversal /> */}
              <ItemUniversalLink
                data={dataCategory?.data}
                year={year}
                month={month}
              />
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
